/** Marks a SearchInput that the app-wide `/` shortcut focuses. */
export const PAGE_SEARCH_ATTR = "data-page-search";
